// ─────────────────────────────────────────────────────────────
//  vitals.js — Core Web Vitals telemetry
//
//  Reports LCP / INP / CLS to /api/activation/track using the
//  existing activation pipeline. Sample rate 100% for now —
//  cheap and we want the signal density on a young app.
//
//  Usage: call initWebVitals() once at app boot (index.js).
//  Usage: call trackRouteLoad(route) on each React Router navigate.
// ─────────────────────────────────────────────────────────────
import { onLCP, onINP, onCLS } from 'web-vitals';
import { track } from './activation';

// Web vitals thresholds (Google's definitions, ms except CLS which is unitless):
//   LCP: good <2500, needs-improvement <4000, poor >=4000
//   INP: good <200,  needs-improvement <500,  poor >=500
//   CLS: good <0.1,  needs-improvement <0.25, poor >=0.25
// web-vitals library already supplies a `rating` field — we just forward it.

function fire(eventName) {
  return (metric) => {
    try {
      track(eventName, {
        value: Math.round(metric.value * 1000) / 1000,
        rating: metric.rating,            // 'good' | 'needs-improvement' | 'poor'
        nav_type: metric.navigationType,  // 'navigate' | 'reload' | 'back-forward' | 'prerender'
        id: metric.id,
      });
    } catch {
      /* noop — telemetry must never break UX */
    }
  };
}

let _initialised = false;

export function initWebVitals() {
  if (_initialised) return;
  _initialised = true;
  try {
    onLCP(fire('vitals_lcp'));
    onINP(fire('vitals_inp'));
    onCLS(fire('vitals_cls'));
  } catch {
    /* noop */
  }
}

// Track React route load time.
// Call at the start of navigation + at first paint after arrival.
let _routeStart = null;
let _lastPath = null;

export function markRouteStart(pathname) {
  _routeStart = performance.now();
  _lastPath = pathname;
}

export function markRouteEnd(pathname) {
  if (_routeStart == null || _lastPath !== pathname) return;
  const duration = Math.round(performance.now() - _routeStart);
  _routeStart = null;
  if (duration > 0 && duration < 60000) {
    try {
      track('route_load', { path: pathname, duration_ms: duration });
    } catch { /* noop */ }
  }
}
